// LanCellRender.jsx
import React from 'react';

const LanCellRender = (props) => {
  return (
    <a href={`http://${props.value}`} target="_blank" rel="noopener noreferrer">
      {props.value}
    </a>
  );
};

export default LanCellRender;